import WorkspacesIcon from '@mui/icons-material/Workspaces';
import GroupList from './GroupList';

export default {
  list: GroupList,
  icon: WorkspacesIcon,
  recordRepresentation: (record: any) => `${record.name}`,
};
